import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container } from '@resurs/midas-react'
import moment from 'moment'
import {
  deleteNewsArticle,
  getFilteredAdminNews,
} from '../../store/actions/news-actions'
import AdminNewsList from './List/AdminNewsList'
import EditNewsContainer from './Edit/EditNewsContainer'
import AdminNewsFilter from './Filter/AdminNewsFilter'
import { useOnMount, useOnUpdate, useToggle } from '../../util/utility-hooks'
import { Features, isEnabled } from '../../models/features'

const InitialPage = Object.freeze({
  pageNumber: 0,
  size: 20,
})

const InitialFilter = Object.freeze({
  publicationDate: moment().startOf('month').toISOString(),
  endDate: moment().endOf('month').toISOString(),
  searchTerm: '',
})

const AdminNewsContainer = ({ fetchAdminNews, deleteArticle }) => {
  const [editMode, toggleEditMode] = useToggle(false)
  const [articleId, setArticleId] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [articles, setArticles] = useState([])
  const [pagination, setPagination] = useState(InitialPage)
  const [filter, setFilter] = useState(
    isEnabled(Features.FILTER_NOTIFICATION) ? InitialFilter : {},
  )

  const onLoadNextPage = (reset = false) => {
    const nextPage = reset ? 0 : pagination.pageNumber + 1
    if (
      !isLoading &&
      (reset || (pagination.totalPages && nextPage < pagination.totalPages))
    ) {
      if (reset) {
        setArticles([])
        setPagination(InitialPage)
      }
      setLoading(true)
      fetchAdminNews({ page: nextPage, size: pagination.size }, filter)
        .then(({ articles: nextArticles, pagination: nextPagination }) => {
          setPagination(nextPagination)
          setArticles(reset ? nextArticles : [...articles, ...nextArticles])
        })
        .finally(() => setLoading(false))
    }
  }

  useOnMount(() => onLoadNextPage(true))

  useOnUpdate(() => !editMode && onLoadNextPage(true), [editMode])

  useEffect(() => onLoadNextPage(true), [filter])

  const onEdit = id => {
    setArticleId(id)
    toggleEditMode()
  }

  const onDelete = id => {
    deleteArticle(id).then(() => onLoadNextPage(true))
  }

  if (editMode) {
    return <EditNewsContainer articleId={articleId} onBack={toggleEditMode} />
  }
  return (
    <Container grid960>
      {isEnabled(Features.FILTER_NOTIFICATION) && (
        <AdminNewsFilter filter={filter} onChange={setFilter} />
      )}
      <AdminNewsList
        isLoading={isLoading}
        articles={articles}
        onEdit={onEdit}
        onDelete={onDelete}
        onLoadNextPage={onLoadNextPage}
      />
    </Container>
  )
}
AdminNewsContainer.propTypes = {
  fetchAdminNews: PropTypes.func.isRequired,
  deleteArticle: PropTypes.func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  fetchAdminNews: (page, filter) =>
    dispatch(getFilteredAdminNews(page, filter)),
  deleteArticle: id => dispatch(deleteNewsArticle(id)),
})

export default connect(null, mapDispatchToProps)(AdminNewsContainer)
